import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const initialState = {
  authToken: "",
  loading: false,
  message: "",
};

export const loginAirline = createAsyncThunk('loginAirline', async () => {
    const parmas = {
        "username": "sgate.shammi@gmail.com",
        "password": "shammi#1234"
    };
    try {
        const url = 'https://cdutils.sgate.net/api/v1/auth/login'
        const response = await fetch(url, {
            headers : {
                "Content-Type": "application/json",
            },
            method: "POST",
            body : JSON.stringify(parmas)
        })
        return await response.json()
    } catch (err) {
        return err.response
    }
})

const loginAirlineSlice = createSlice({
  name: "loginAirline",
  initialState,
  extraReducers: {
    [loginAirline.pending]: (state, action) => {
      state.loading = true;
    },
    [loginAirline.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        authToken: payload?.token,
      };
    },
    [loginAirline.rejected]: (state, action) => {
      state.user = null;
      state.message = action.payload;
    },
  },
});

export const authtokenloginAirline = (state) => state.userAirlineLogin.authToken;

export default loginAirlineSlice.reducer;
